import React, { useState, useEffect, useCallback, useContext  } from 'react';
import { GrammarFillin } from './GrammarInputs';
import StartButton from '../../buttons/StartButton.jsx';
import { API_URL } from '../../../config';
import { useAuth } from "react-oidc-context";
import { GameContext } from '../../../GameContext';

const VerbConjugationsQuiz = ({onResultUpdate, shouldEnd, onEndComplete}) => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [isGameActive, setIsGameActive] = useState(false)
  const [isAnswerSelected, setIsAnswerSelected] = useState(true);
  const [userInput, setUserInput] = useState('');
  const [question, setQuestion] = useState('');
  const [correctAnswer, setCorrectAnswer] = useState('');
  const { selectedLanguage, languageData, learnedWords, updateLearnedList, loadLanguageData, grammarQuestionsList, 
      learnedGrammarList, loadGrammarQuestions, loadUsersLearnedGrammar, updateLearnedGrammarList } = useContext(GameContext);
  const selectedGrammarExercise = 'verbConjugations';

  const handleGameStart = useCallback(async(started) => {
    if (started) {
  console.log('Starting new verb conjugation session')
  console.log(selectedLanguage)
  try {
    const initResponse = await fetch(`${API_URL}/api/new-grammar-exercise`, {
      method: 'POST',
      credentials: 'include',
      headers: {'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ vocab_list: languageData,
          selected_grammar_exercise: selectedGrammarExercise }),
    });
    const initData = await initResponse.json();
    console.log("Verb conjugation initialized:", initData);
    loadUsersLearnedGrammar(initData.learnedGrammarList);
    loadGrammarQuestions(initData.grammarQuestionsList);
    console.log('length of verb file = ' + initData.grammarQuestionsList.length)

    setIsGameActive(true);
    setIsAnswerSelected(false);
    onResultUpdate({
      feedback: ''
    });
    const wordList = initData.grammarQuestionsList;
    await fetchNewWord(wordList);
  } catch (error) {
    console.error('Error starting verb conjugation:', error);
    onResultUpdate({
      feedback: 'An error occurred while evaluating your verb conjugation answer. Please try again.'
    });
  }
  setIsAnswerSelected(false);
}else {
  await endGame();
}
});

const fetchNewWord = async (wordList = null) => {
  console.log("Starting the verb conjugation game process");
  console.log("selected grammar exercise = "+ selectedGrammarExercise)
  const listToUse = wordList || grammarQuestionsList;
  setIsAnswerSelected(false);  // Reset answer selected state first
  setUserInput(''); 

    try {
      const response = await fetch(`${API_URL}/api/generate-grammar-question`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ 
              selected_grammar_exercise: selectedGrammarExercise,
              selected_grammar_questions_list: listToUse,
              learned_grammar_list: learnedGrammarList
            }),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch verb conjugaton question');
      }
      const data = await response.json();
      setCorrectAnswer(data.generatedAnswer);
      setQuestion(data.generatedQuestion);
      console.log(data.generatedQuestion)
    } catch (error) {
        console.log('Error fetching verb conjugation question:');
      }
  setUserInput('');
};

const handleInputChange = (e) => {
  setUserInput(e.target.value);
};

const handleAnswerSelected = useCallback(async (selected) => {
  console.log("Handling Answer for verb conjugation...");
  console.log("Current question:", question);  
  console.log("User answer:", selected);      
  console.log("Correct answer:", correctAnswer);
  
  setIsAnswerSelected(true);

  try {
    const response = await fetch(`${API_URL}/api/process-grammar-fillin`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        userAnswer: selected,
        correctAnswer: correctAnswer,
        question: question,
        grammarExercise: selectedGrammarExercise, 
        selected_grammar_questions_list: grammarQuestionsList
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    console.log("Evaluation verb conjugation result:", result);

    onResultUpdate({
      feedback: result.feedback
    });
    setUserInput('');

    updateLearnedGrammarList(result.learned_grammar_list)

  } catch (error) {
    console.error('Error evaluating verb conjugation answer:', error);
  }

}, [selectedGrammarExercise, fetchNewWord, onResultUpdate]);

const endGame = useCallback(async () => {
  console.log("Ending the conjugation game process");
  if (!isGameActive) return;

  try {
    const response = await fetch(`${API_URL}/api/end-grammar-quiz`, {
      method: 'POST',
      credentials: 'include',
      headers: {'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        grammarExercise: selectedGrammarExercise, 
        learned_grammar_list: learnedGrammarList
      }),
    });
    if (!response.ok) {
      throw new Error('Failed to end conjugation game on server');
    }
    const data = await response.json();
    console.log("Verb conjugation result:", data);

    onResultUpdate({
      feedback: data.feedback
    });

  } catch (error) {
    console.error("Error ending verb conjugation game on server:", error);
  } finally {
    setIsGameActive(false);
    setUserInput('');
    onEndComplete();
    setIsAnswerSelected(true);
  }
}, [isGameActive, onResultUpdate, onEndComplete]);

  useEffect(() => {
    //used to fire when the quiz is switched to another grammar exercise
    if (shouldEnd) {
      console.log(`Running end game process for verb conjugation`);
      endGame();
      onEndComplete();
    }
  }, [shouldEnd, isGameActive, onEndComplete]);

  const QuestionDisplay = ({ question }) => {
    //used to display formatted text pull from Python
    if (!question?.text) return null;
    const { text, styles } = question;
    return (
      <div>
        {text.prefix}
        <strong className={styles.verb.classes}>
          {text.verb}
        </strong>
        {text.suffix}
      </div>
    );
  };

return(

<div className="card border-0">
      <div className="card-body">
        <h5 className="mb-2">
          {isGameActive ? (
            <span className="custom-text-primary">Write the correct conjugation for the following verb and person</span>
          ) : (
            <span className="custom-text-primary">Click Start to begin</span>
          )}
       </h5>
    <div style={{ marginBottom: '40px' }}></div>
    <QuestionDisplay question={question} />
    <div style={{ marginBottom: '20px' }}></div>
        
        <GrammarFillin 
        onSubmit={() => handleAnswerSelected(userInput)}
        userInput={userInput}
        onInputChange={handleInputChange}
        isSubmitted={isAnswerSelected}/>
      </div>
      <div class="d-flex justify-content-between">
      <button className="btn btn-success custom-next-button btn-block mt-2 w-75" 
              type="button" 
              id="continueButton"
              onClick={() => fetchNewWord()}    
              disabled={!isAnswerSelected || !isGameActive}>Continue</button>
        <StartButton
          onToggle={handleGameStart}
          id="grammarStartButton"  
          isStarted={isGameActive}
        />
    </div>
    </div>

);

};

export default VerbConjugationsQuiz;